import http from '@/http'
import User from '@/store/models/User'
import UserNotification from '@/store/models/UserNotification'

const API_PATH = 'organizations/:organizationId/user_notifications/'

const configureApiPath = ({ organizationId }) => {
  return API_PATH.replace(':organizationId', organizationId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async index({ commit, rootGetters }) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    await http.get(apiPath).then(response => {
      UserNotification.deleteAll()
      User.insert({
        data: response.data.included.filter(
                                      resource => resource.type === 'user'
                                      && resource.id != rootGetters['auth/signedInUser'].id
                                      && !User.query().where('id', Number(resource.id)).exists()
                                    ).map(user => user.attributes)
      })
      UserNotification.insert({
        data: response.data.data.map(userNotification => Object.assign(userNotification.attributes, {
          senderId: userNotification.relationships.sender.data.id
        }))
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async updateToRead({ commit, rootGetters }, id) {
    const params = JSON.stringify({
      userNotification: {
        isRead: true
      }
    })
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    await http.put(apiPath + id, params).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
